import React, { useState } from 'react';
import { Box, ButtonBase, Typography, makeStyles } from '@material-ui/core';
import _classNames from 'classnames';
import Mixpanel from 'utils/mixpanelService';
import FAQsIcon from './icons/FAQ.svg';
import SupportModal from './components/SupportModal';
import { getSupportTypeName } from './utils';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: 8,
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginRight: '0px !important',
    padding: '0px !important',
  },
  text: {
    fontWeight: 700,
    fontSize: 12,
  },
});

const SupportWidget = ({
  widgetCopy,
  getMixpanelData,
  type = 'support',
  containerClassName,
  textClassName,
  ...supportModalProps
}) => {
  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const helpText = widgetCopy?.needHelp || 'Need help?';

  const supportTypeName = getSupportTypeName(type);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);

    const mixpanelData = getMixpanelData?.() || {};
    Mixpanel.track(`${supportTypeName} - Need Help - Clicked`, {
      ...mixpanelData,
    });
  };

  return (
    <>
      <Box className={_classNames(classes.container, containerClassName)}>
        <ButtonBase focusRipple onClick={handleOpen} className={classes.button}>
          <img src={FAQsIcon} alt="" />
          <Typography
            color="primary"
            className={_classNames(classes.text, textClassName)}
          >
            {helpText}
          </Typography>
        </ButtonBase>
      </Box>
      {open && (
        <SupportModal
          onClose={handleClose}
          widgetCopy={widgetCopy}
          getMixpanelData={getMixpanelData}
          type={type}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...supportModalProps}
        />
      )}
    </>
  );
};

export default SupportWidget;
